package co.maytes.standupbot.dashboard.components.widgets

import androidx.compose.runtime.Composable
import co.maytes.standupbot.dashboard.styles.Layout
import co.maytes.standupbot.dashboard.styles.Palette
import co.maytes.standupbot.dashboard.styles.Spacing
import co.maytes.standupbot.dashboard.styles.Tracking
import co.maytes.standupbot.dashboard.styles.Typography
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.letterSpacing
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.silk.components.text.SpanText

/**
 * Standard intro for every authenticated page: optional eyebrow, H1 title,
 * optional subtitle, optional right-aligned action slot. Titles use Inter
 * (not mono) — precision mono is reserved for display moments. Pages should
 * drop their ad-hoc H1 + Row wrappers for this.
 */
@Composable
fun AppPageHeader(
    title: String,
    eyebrow: String? = null,
    subtitle: String? = null,
    modifier: Modifier = Modifier,
    action: (@Composable () -> Unit)? = null,
) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .margin(bottom = Spacing.lg)
            .then(modifier),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically,
    ) {
        Column {
            SpanText(
                text = title,
                modifier = Modifier
                    .fontSize(Typography.h1.size)
                    .fontWeight(Typography.h1.weight)
                    .color(Palette.textPrimary)
                    .letterSpacing(Tracking.tight),
            )
            if (subtitle != null) {
                SpanText(
                    text = subtitle,
                    modifier = Modifier
                        .margin(top = Spacing.xs)
                        .fontSize(Typography.body.size)
                        .color(Palette.textSecondary)
                        .maxWidth(Layout.reading),
                )
            }
        }
        if (action != null) {
            Box { action() }
        }
    }
}
